import React, { lazy } from 'react';
import { FadeInUp } from './ui/FadeInUp';
import { SectionEyebrow } from './ui/SectionEyebrow';
import { ArrowRight } from 'lucide-react';
const areas = [{
  name: 'Gilbert',
  image: 'https://cdn.magicpatterns.com/uploads/uW6tcMe8povXMCnGEqWRUo/gilbert-az-400-300.jpg'
}, {
  name: 'Chandler',
  image: 'https://cdn.magicpatterns.com/uploads/o3FtdmyUbmGkJCFh7SYeQu/chandler-az-400-300.jpg'
}, {
  name: 'Mesa',
  image: 'https://cdn.magicpatterns.com/uploads/hWhBh13JWY3FhMGPqvH4bB/mesa-az-400-300.jpg'
}, {
  name: 'Queen Creek',
  image: 'https://cdn.magicpatterns.com/uploads/eoBUPeQFcJ7w1i3CgCzdsR/queen-creek-az-400-300.jpg'
}, {
  name: 'Scottsdale',
  image: 'https://cdn.magicpatterns.com/uploads/5hgp4aapnmLbSFnh8SjfWC/scottsdalel-az-400-300.jpg'
}, {
  name: 'Other Areas',
  image: 'https://cdn.magicpatterns.com/uploads/1DCof8D9Nenn7JyP9kJRmg/other-cities-az-400-300.jpg'
}];
export function AreasSection() {
  return <section className="py-24 md:py-32 bg-ivory" data-id="element-39">
      <div className="container mx-auto px-6" data-id="element-40">
        <FadeInUp className="text-center max-w-2xl mx-auto mb-16 md:mb-24" data-id="element-41">
          <SectionEyebrow text="Where We Work" data-id="element-42" />
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-43">
            Areas to Call Home
          </h2>
          <p className="text-charcoal-text/70 text-lg" data-id="element-44">
            Three decades of deep local knowledge across the Phoenix Metro area.
          </p>
        </FadeInUp>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5 max-w-5xl mx-auto" data-id="element-45">
          {areas.map((area, index) => <FadeInUp key={area.name} delay={index * 0.1} data-id="element-46">
              <a href="#" className="group block relative aspect-[3/2] rounded-xl overflow-hidden shadow-sm" data-id="element-47">
                {/* Image */}
                <img src={area.image} alt={`${area.name} real estate`} loading="lazy" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-[1200ms] ease-out group-hover:scale-110" data-id="element-48" />

                {/* Dark gradient overlay — covers bottom ~40%, fades to transparent at the top */}
                <div className="absolute inset-x-0 bottom-0 h-2/5 bg-gradient-to-t from-black/70 to-transparent transition-opacity duration-300 group-hover:from-black/85" data-id="element-49" />

                <div className="absolute left-0 bottom-0 pl-6 pr-6 pb-5" style={{
              paddingLeft: '24px',
              paddingBottom: '20px'
            }} data-id="element-50">
                  <h3 className="font-serif text-white tracking-tight text-[24px] md:text-[30px] leading-none" style={{
                textShadow: '0 2px 8px rgba(0,0,0,0.5)'
              }} data-id="element-51">
                    {area.name}
                  </h3>
                  <div className="flex items-center text-terracotta text-sm font-medium mt-3 opacity-0 -translate-y-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0" data-id="element-52">
                    View Homes <ArrowRight className="w-4 h-4 ml-2" data-id="element-53" />
                  </div>
                </div>
              </a>
            </FadeInUp>)}
        </div>
      </div>
    </section>;
}